import React, { useContext } from 'react'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import styled from 'styled-components'

const FormalityTags = () => {
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const tags = legalFormality.tags

  if (!tags) {
    return null
  }

  return (
    <FormalityTagsWrapper>
      {tags.map(tag => (
        <Tag key={`Tag-${tag}`}>{tag}</Tag>
      ))}
    </FormalityTagsWrapper>
  )
}

export default FormalityTags

const FormalityTagsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`

const Tag = styled.span`
  border: 2px solid rgb(0, 123, 255);
  background-color: rgba(0, 123, 255, 0.8);
  padding: 5px 10px;
  border-radius: 8px;
  color: white;
  font-weight: bold;
`
